(() => {
  const floatingContactButtons = document.querySelector('.floating-contact-buttons');
  const scrollToTopButton = document.querySelector('[data-scroll-to-top]');
  const whatsappButton = document.querySelector('.floating-contact-buttons__button--whatsapp');
  const productMobileQuoteBar = document.querySelector('.product-mobile-quote-bar-v13');
  const contactButtons = floatingContactButtons
    ? Array.from(floatingContactButtons.querySelectorAll('.floating-contact-buttons__button'))
    : [];

  const previewBarSelector = [
    '#preview-bar-iframe',
    '#PBarNextFrame',
    '#PBarNextFrameWrapper',
    'iframe[src*="preview_bar"]',
    'iframe[src*="/preview-bar/"]',
    '.shopify-preview-bar',
  ].join(',');

  let previewBarFrame;
  const observedPreviewBars = new Set();
  const previewBarResizeObserver = productMobileQuoteBar && 'ResizeObserver' in window
    ? new ResizeObserver(() => schedulePreviewBarOffsetUpdate())
    : null;

  const updatePreviewBarOffset = () => {
    previewBarFrame = undefined;

    const previewBars = Array.from(document.querySelectorAll(previewBarSelector));
    previewBars.forEach((previewBar) => {
      if (!previewBarResizeObserver || observedPreviewBars.has(previewBar)) {
        return;
      }

      observedPreviewBars.add(previewBar);
      previewBarResizeObserver.observe(previewBar);
    });

    const offset = previewBars.reduce((largestOffset, previewBar) => {
      const style = window.getComputedStyle(previewBar);
      const rect = previewBar.getBoundingClientRect();
      const maximumBarHeight = Math.min(180, window.innerHeight * 0.35);

      if (
        style.display === 'none'
        || style.visibility === 'hidden'
        || Number(style.opacity || 1) <= 0
        || rect.width <= 0
        || rect.height <= 0
        || rect.height > maximumBarHeight
        || rect.bottom < window.innerHeight - 1
        || rect.top >= window.innerHeight
      ) {
        return largestOffset;
      }

      return Math.max(largestOffset, window.innerHeight - Math.max(0, rect.top));
    }, 0);

    document.documentElement.style.setProperty('--dibao-preview-bar-offset', `${Math.ceil(offset)}px`);
  };

  function schedulePreviewBarOffsetUpdate() {
    if (previewBarFrame !== undefined) {
      return;
    }

    previewBarFrame = window.requestAnimationFrame(updatePreviewBarOffset);
  }

  if (productMobileQuoteBar) {
    const previewBarMutationObserver = new MutationObserver(schedulePreviewBarOffsetUpdate);
    previewBarMutationObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', schedulePreviewBarOffsetUpdate, { once: true });
    window.addEventListener('resize', schedulePreviewBarOffsetUpdate, { passive: true });
    schedulePreviewBarOffsetUpdate();
  }

  if (!scrollToTopButton) {
    return;
  }

  let collisionFrame;

  const collisionSelector = [
    'main a',
    'main button',
    'footer a',
    'footer button',
    previewBarSelector,
  ].join(',');

  const setCollisionState = (shouldAvoid) => {
    if (shouldAvoid && floatingContactButtons?.matches(':focus-within')) {
      return;
    }

    if (!floatingContactButtons || floatingContactButtons.classList.contains('is-collision-avoiding') === shouldAvoid) {
      return;
    }

    floatingContactButtons.classList.toggle('is-collision-avoiding', shouldAvoid);
    contactButtons.forEach((button) => {
      if (shouldAvoid) {
        button.setAttribute('tabindex', '-1');
      } else {
        button.removeAttribute('tabindex');
      }
    });

    if (shouldAvoid) {
      floatingContactButtons.setAttribute('aria-hidden', 'true');
    } else {
      floatingContactButtons.removeAttribute('aria-hidden');
    }
  };

  const updateCollisionState = () => {
    collisionFrame = undefined;

    if (!floatingContactButtons || !whatsappButton) {
      return;
    }

    const rect = floatingContactButtons.getBoundingClientRect();

    if (rect.width <= 0 || rect.height <= 0) {
      setCollisionState(false);
      return;
    }

    const clearance = 6;
    const xPoints = [
      rect.left - clearance,
      rect.left + rect.width * 0.25,
      rect.left + rect.width * 0.5,
      rect.left + rect.width * 0.75,
      rect.right + clearance,
    ];
    const yPoints = [
      rect.top - clearance,
      rect.top + rect.height * 0.25,
      rect.top + rect.height * 0.5,
      rect.top + rect.height * 0.75,
      rect.bottom + clearance,
    ];
    const collides = xPoints.some((x) =>
      yPoints.some((y) => {
        const safeX = Math.min(Math.max(x, 0), window.innerWidth - 1);
        const safeY = Math.min(Math.max(y, 0), window.innerHeight - 1);

        return document.elementsFromPoint(safeX, safeY).some((element) => {
          const target = element.closest?.(collisionSelector);
          return target && !floatingContactButtons.contains(target);
        });
      }),
    );

    setCollisionState(collides);
  };

  const scheduleWhatsappCollisionCheck = () => {
    if (collisionFrame !== undefined) {
      return;
    }

    collisionFrame = window.requestAnimationFrame(updateCollisionState);
  };

  const updateButtonVisibility = () => {
    scrollToTopButton.hidden = window.scrollY < 360;
  };

  scrollToTopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });

  window.addEventListener('scroll', () => {
    updateButtonVisibility();
    scheduleWhatsappCollisionCheck();
  }, { passive: true });
  window.addEventListener('resize', scheduleWhatsappCollisionCheck, { passive: true });
  document.addEventListener('shopify:section:load', scheduleWhatsappCollisionCheck);
  floatingContactButtons?.addEventListener('focusin', () => setCollisionState(false));
  floatingContactButtons?.addEventListener('focusout', () => {
    window.requestAnimationFrame(scheduleWhatsappCollisionCheck);
  });
  updateButtonVisibility();
  updateCollisionState();
})();
